<template>
    <div class="page__title--secondary">
        <div class="page__title-txt--secondary">{{ title }}</div>
    </div>
</template>

<script>
export default {
    name: 'PageTitleSecondary',
    props: {
        title: {
            type: String,
            required: true,
            default: ''
        }
    }
}
</script>

<style lang="less">
 @import '../../global/variable';
.page__title--secondary {
    height: 77px;
    line-height: 77px;
    background-color: var(--src-text-color-white-dark1);
    font-size: var(--src--text-size-large-extra3);
    color: var(--src-color-primary-dark2);
    font-weight: var(--src-text-weight-dark1);
}

.page__title-txt--secondary{
    .pageMaxWidth();
    margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/PageTitleSecondary.vue